import React, { useState, useCallback } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from '@mui/material/Tooltip';
import withStyles from '@mui/styles/withStyles';
import ToolTipBody from './ToolTipBody';
import { ValidPasswordToolTipProps } from '../types';

const HtmlTooltip = withStyles(() => ({
  tooltip: {
    background: '#fff',
    border: '1px solid #2a2a2a',
    borderRadius: '10px',
    padding: '0.5rem'
  },
  popper: {
    zIndex: 2147483647
  }
}))(Tooltip);

export const ValidPasswordToolTip: React.FC<ValidPasswordToolTipProps> = (props: ValidPasswordToolTipProps) => {
  const [showOnHover, setShowOnHover] = useState(false);

  const toggleTooltipHoverVisibility = useCallback(() => {
    if (!props.showValidPasswordInfo) {
      setShowOnHover((showItOnHover) => !showItOnHover);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.showValidPasswordInfo, showOnHover]);

  return (
    <>
      <HtmlTooltip
        open={props.showValidPasswordInfo || showOnHover}
        disableFocusListener
        disableTouchListener
        title={<ToolTipBody value={props.value} />}
        placement="top-end"
      >
        <span
          data-testid="pwd-info"
          onMouseEnter={() => toggleTooltipHoverVisibility()}
          onMouseLeave={() => toggleTooltipHoverVisibility()}
        >
          <InfoOutlinedIcon />
        </span>
      </HtmlTooltip>
    </>
  );
};
